import { render, staticRenderFns } from "./colorForm.vue?vue&type=template&id=ae3b18d2&"
import script from "./colorForm.vue?vue&type=script&lang=ts&"
export * from "./colorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports